import * as React from "react";
import AdaptiveCard from "../../live/components/adaptiveCard";
import CardComponent from "../CardComponent";
import { Carousel } from "antd";
import "./style.css";
import { useSelector } from "react-redux";

export interface ICarouselProps {
  cards: any[];
  data: any;
  id: string;
  chats: any[];
}

const handleCardButtonClick = () => {};

const renderContent = (
  card: any,
  index: number,
  data: any,
  id: string,
  chats: any[],
  shouldShowActions: boolean
) => {
  switch (card.type) {
    case "adaptiveCard": {
      const { from, fromName } = data;
      const { template, data: cardData, isFeedBack } = card;

      return (
        <AdaptiveCard
          key={index}
          from={from}
          fromName={fromName}
          template={template}
          data={cardData}
          isFeedback={isFeedBack}
          id={id}
          type="carousel"
        />
      );
    }
    default: {
      return (
        <CardComponent
          key={index}
          card={card}
          index={index}
          handleCardButtonClick={handleCardButtonClick}
          shouldShowActions={shouldShowActions}
        />
      );
    }
  }
};

export default function CarouselComponent(props: ICarouselProps) {
  const { cards, data, id, chats } = props;
  // const chats = useSelector((state: any) => state.chat.assignedChats);
  const shouldShowActions =
    chats[chats.length - 1].msgType === "carousel" &&
    id === chats[chats.length - 1].id;
  return (
    <div style={{ width: "400px", marginLeft: "auto" }}>
      <Carousel dotPosition="bottom">
        {cards.map((card, index) =>
          renderContent(card, index, data, id, chats, shouldShowActions)
        )}
      </Carousel>
    </div>
  );
}
